import 'magnific-popup';
import Packery from 'packery';
import tooltip from 'bootstrap/js/src/tooltip'
import dropdown from 'bootstrap/js/src/dropdown';
import collapse from 'bootstrap/js/src/collapse'
import Isotope from 'isotope-layout';
import isopackery from 'isotope-packery';
import imagesLoaded from 'imagesloaded';

import Glide from '@glidejs/glide/dist/glide.esm'
window.$ = $;
window.jQuery = $;


$(function () {

    var grid = document.querySelector('.grid'),
        filterFns = {},
        fabricsCat = document.querySelector('#fabrics'),
        headline = document.querySelector('.js-headline'),
        fabricVariantName = document.querySelector('#fabric-variant-name'),
        thumbs = document.querySelector('#thumbs'),
        $filtersElem = $('.filter-button-group'),
        iso;

    $('#thumbs img').click(function () {
        $('#largeImage').attr('src', $(this).attr('src').replace('thumb', 'large'));
        $('#description').html($(this).attr('alt'));
        const test = $('.swatch').text();
        $('.js-product-color').text($(event.target).data('original-title'));
    });

    $('.popup-gallery').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            titleSrc: function (item) {
                return item.el.attr('title');
            }
        }
    });

    $('[data-toggle="tooltip"]').tooltip();


    if (fabricsCat) {
        fabricsCat.addEventListener('click', function (e) {
            localStorage.setItem('category', e.target.dataset.category);
        });
    }

    if (thumbs) {
        thumbs.addEventListener('click', function (e) {
            var code = e.target.getAttribute('alt');
            fabricVariantName.textContent = code;
        });
    }


    if (grid) {

        imagesLoaded(grid, function () {
            iso = new Isotope('.grid', {
                layoutMode: 'packery',
                packery : {
                    itemSelector: '.element-item',
                    columnWidth: 300,
                    gutter: 20
                }
            });
            $(".grid-loader").hide().remove();
            $(".grid").addClass('show');

        });
    }

    if ($filtersElem.length > 0) {

        $filtersElem.find('button').each(function () {
           var $btn = $(this);
           $btn.on('click', function (e) {
               e.preventDefault();

               $filtersElem.find('.btn-dark-grey').removeClass('btn-dark-grey').addClass('btn-light-grey');
               $btn.removeClass('btn-light-grey').addClass('btn-dark-grey');

               if ($btn.data('filter')) {
                   headline.textContent = $btn.text();
               }

               iso.arrange({filter: $btn.data('filter')});
           });
        });
    }


    if (document.querySelectorAll('.slider').length > 0) {
        new Glide('.slider', {
            type: 'carousel',
            autoplay: $('.slider').data('delay'),
            startAt: 0,
            perView: 1,
            gap: 0,
        }).mount()
    }

    $(".show-request-form-footer").on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('keep')) {
            $(this).next(".request-form-footer").slideToggle('fast');
        } else {
            $(this).hide().removeClass('d-block').next(".request-form-footer").slideDown('fast');
        }
    });


    $(".mobile-info-toggle").on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var caption = $(this).closest('.inspiration-item').find('figcaption');
        caption.toggleClass('show');
        caption.on('click', function () {
            if (caption.hasClass('show')) {
                caption.removeClass('show');
            }
        });
    });

    $("[data-remove-me]").each(function () {
        var $this = $(this),
            time = $this.data('remove-me');

        setTimeout(function () {
            $this.fadeOut('slow', function () {
                $this.remove();
            });
        }, time);
    });

    $("[data-trigger-click]").each(function () {
        var $this = $(this);
        if ($this.data('trigger-click')) {
            $this.trigger('click');
        }
    })

    $('.nav-link').on('touchstart, touchend', function () {
        $(this).toggleClass('touched');
    });
});